import { tracker } from '../track';
import { mapArticleToGA4EcommerceItem } from '../../helpers';
export const trackSelectPromotion = (payload, options) => {
    var _a, _b, _c;
    try {
        const { creativeName, element, itemListName, item, creativeSlot } = payload;
        tracker.track('GA4-EEC-select_promotion', {
            event_name: 'select_promotion',
            select_promotion: {
                element: element || null,
                creative_name: creativeName || null,
                creative_slot: creativeSlot !== undefined ? creativeSlot : null,
                promotion_id: item.campaignIdentifier || null,
                promotion_name: null,
                items: [
                    mapArticleToGA4EcommerceItem(Object.assign({ affiliation: item.categoryId || null, early_access_item: (_a = item.earlyAccessItem) !== null && _a !== void 0 ? _a : null, index: (_b = item.index) !== null && _b !== void 0 ? _b : 0, item_list_name: itemListName, promotion_id: item.campaignIdentifier, plus_exclusive: (item === null || item === void 0 ? void 0 : item.isExclusiveItem) || null }, (_c = options === null || options === void 0 ? void 0 : options.customMapper) === null || _c === void 0 ? void 0 : _c.call(options, item))),
                ],
            },
        });
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('[@browsing/tracker] Tracking `select_promotion` failed.', e);
    }
};
